export default __webpack_public_path__ + "static/media/knife.510c6880.jpg";